// prettier-ignore
export default "fn"